import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
        <Path
            fill={props.color ?? ds.colorValue.icon.primary}
            d="m10.994 4.695-4.47 4.47H17.5v1.667H6.525l4.469 4.47-1.18 1.178-6.48-6.482 6.48-6.481 1.18 1.178Z"
        />
    </Svg>
);
export default SvgComponent;
